import React, { useState, useEffect } from "react";
import { Box, Grid, Item, Typography } from "@mui/material";
import { IconButton } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import Chart from "react-apexcharts";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/system";

const MyGrid = styled(Grid)({
  "&:hover": {
    backgroundColor: "#2d79db22",
    cursor: "pointer",
    transform: "scale(1.02,1.02)",
  },
});

const SingleStockRow = ({ stock, token, mode }) => {
  const navigate = useNavigate();
  const [logo, setLogo] = useState("");
  const [price, setPrice] = useState(-1);
  const [priceChange, setPriceChange] = useState(-1);
  const [volume, setVolume] = useState(null);
  const [marketCap, setMarketCap] = useState("");
  const [chartSeriesData, setChartSeriesData] = useState([{ data: [] }]);
  const [graphDirection, setGraphDirection] = useState("");

  useEffect(() => {
    axios
      .get(
        `https://cloud.iexapis.com/stable/stock/${stock?.symbol}/quote?token=${token}`
      )
      .then((res) => {
        // console.log(stock?.symbol, "pryce", res.data);
        setPrice(res.data?.latestPrice);
        setPriceChange(res.data?.change);
        setMarketCap(res.data?.marketCap);
        setVolume(res.data?.marketCap);
      })
      .catch((err) => console.log(err));

    /************ logo */
    // axios
    //   .get(
    //     `https://cloud.iexapis.com/stable/stock/${stock?.symbol}/logo?token=${token}`
    //   )
    //   .then((res) => {
    //     // console.log("logo", res.data);
    //     setLogo(res.data?.url);
    //   })
    //   .catch((err) => console.log(err));

    /*********historical prices */
    axios
      .get(
        ` https://cloud.iexapis.com/stable/stock/${stock?.symbol}/chart/1m?token=${token}&&chartCloseOnly=true`
      )
      .then((res) => {
        // console.log("historical price", res.data);
        let prices = res.data;
        prices = prices.map((p) => [p?.date, p?.close]);
        if (prices[0][1] > prices[prices?.length - 1][1]) {
          setGraphDirection("down");
        } else {
          setGraphDirection("up");
        }

        setChartSeriesData([{ data: prices }]);
      })
      .catch((err) => console.log(err));
  }, []);

  const round = (n) => {
    return n ? +n.toFixed(2) : null;
  };
  /*** */
  var options = {
    series: [
      {
        name: "STOCK ABC",
        data: [],
      },
    ],
    chart: {
      type: "area",
      height: 0,
      zoom: {
        enabled: false,
      },
      toolbar: {
        autoSelected: "pan",
        show: false,
      },
    },
    // fill: {
    //   colors: ["#000000"],
    // },
    theme: {
      mode: mode,
      palette: "palette1",
      monochrome: {
        enabled: true,
        color: "#22b55a",
        shadeTo: "light",
        shadeIntensity: 0.05,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 1,
    },

    title: {
      text: "",
      align: "left",
    },
    subtitle: {
      text: "",
      align: "left",
    },
    // labels: series.monthDataSeries1.dates,
    grid: {
      show: false,
    },
    xaxis: {
      type: "datetime",
      labels: {
        show: false,
      },
      lines: {
        show: false, //or just here to disable only x axis grids
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      opposite: true,
      labels: {
        show: false,
      },
    },
    legend: {
      horizontalAlign: "left",
    },
  };

  var options2 = {
    series: [
      {
        name: "STOCK ABC",
        data: [],
      },
    ],
    chart: {
      type: "area",
      height: 0,
      zoom: {
        enabled: false,
      },
      toolbar: {
        autoSelected: "pan",
        show: false,
      },
    },
    // fill: {
    //   colors: ["#000000"],
    // },
    theme: {
      monochrome: {
        enabled: true,
        color: "#ec544c",
        shadeTo: "light",
        shadeIntensity: 0.05,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 1,
    },

    title: {
      text: "",
      align: "left",
    },
    subtitle: {
      text: "",
      align: "left",
    },
    // labels: series.monthDataSeries1.dates,
    grid: {
      show: false,
    },
    xaxis: {
      type: "datetime",
      labels: {
        show: false,
      },
      lines: {
        show: false, //or just here to disable only x axis grids
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      opposite: true,
      labels: {
        show: false,
      },
    },
    legend: {
      horizontalAlign: "left",
    },
  };

  return (
    <MyGrid
      container
      spacing={0}
      sx={{
        fontWeight: 300,
        fontFamily: "Public Sans",
        fontSize: "1em",
        // borderBottom: "0.8px solid lightgray",
        color: "fontPrimaryColor.main",
        padding: "10px 5px",
        alignItems: "center",
        height: "80px",
      }}
      onClick={() => navigate(`/complete__details/stock/${stock?.symbol}`)}
    >
      <Grid item xs={0.8} sm={0.6}>
        <IconButton
          style={{
            width: "10px",
            height: "10px",
            color: "#b1b1b1",
          }}
        >
          <StarBorderIcon style={{ fontSize: "1rem" }} />
        </IconButton>
      </Grid>
      <Grid item xs={3.2} md={2.6}>
        {/* {logo ? (
          <img
            src={logo + `?token=${token}`}
            style={{
              height: "1.8rem",
              maxWidth: "80%",
              maxHeight: "20px",
              minHeight: "10px",
            }}
          />
        ) : (
          "N/A"
        )} */}
        <Typography
          sx={{
            fontFamily: "public sans",
            fontSize: { xs: "0.67rem", sm: "0.77rem" },
            padding: "0 10px 0 0",
            fontWeight: "600",
          }}
        >
          {stock?.name}
        </Typography>
      </Grid>
      <Grid item xs={1.7} sm={2} md={1.6}>
        <Typography
          sx={{
            color: "#8c8c8c",
            fontFamily: "public sans",
            fontSize: { xs: "0.8rem", sm: "0.9rem" },
          }}
        >
          {stock?.symbol}
        </Typography>
      </Grid>
      <Grid
        item
        xs={0}
        md={1.3}
        sx={{ display: { md: "inline-block", xs: "none" } }}
      >
        <Typography
          sx={{
            color: "fontPrimaryColor.main",
            fontFamily: "public sans",
            fontSize: "0.9rem",
          }}
        >
          {marketCap && numFormatter(marketCap)}
        </Typography>
      </Grid>
      <Grid item xs={4.2} md={4.4}>
        <Box
          sx={{
            maxHeight: "50px",
            marginTop: "-60px",
          }}
        >
          <Chart
            options={graphDirection == "up" ? options : options2}
            series={chartSeriesData}
            type="area"
            height={100}
            width="100%"
          />
        </Box>
      </Grid>
      <Grid item xs={1.5}>
        <Box
          sx={{
            // border: "1px solid black",
            height: "60px",
            display: "flex",
            flexDirection: "column",
            alignItems: "left",
            justifyContent: "center",
            padding: "5px",
            color: "fontPrimaryColor.main",
            fontFamily: "Public Sans",
            fontWeight: "400",
          }}
        >
          <Typography
            variant={"h6"}
            sx={{
              textAlign: "right",
              paddingRight: "10px",
              fontSize: { xs: "0.7rem", sm: "0.9rem" },
              fontFamily: "Public Sans",
              fontWeight: "400",
            }}
          >
            ${price}
          </Typography>
          <Typography
            sx={{
              textAlign: "right",
              paddingRight: "10px",
              fontSize: { xs: "0.6rem", sm: "0.75rem" },
              fontFamily: "Public Sans",
              fontWeight: "400",
              color:
                priceChange > 0 ? "ourGreenColor.main" : "ourRedColor.main",
            }}
          >
            {!priceChange
              ? "N/A"
              : priceChange > 0
              ? "+" + priceChange
              : priceChange}
          </Typography>

          {/* <h6>{price > 0 ? `$${price}` : "loading"}</h6> */}
          {/* <h6 className={priceChange < 0 ? "price__down" : "price__up"}>
            {priceChange ? priceChange : "N/A"}
          </h6> */}
        </Box>
      </Grid>
    </MyGrid>
  );
};

export default SingleStockRow;

function numFormatter(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num > 1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num > 100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num < 900) {
    return num; // if value < 1000, nothing to do
  }
}
